import { Component, OnInit } from "@angular/core";
import { Data, Router } from "@angular/router";
import { ModalController, NavParams, IonicModule } from "@ionic/angular";
import { TranslateService, TranslatePipe } from "@ngx-translate/core";
import { AuthService } from "@core/auth.service";
import { GTMSegmentService } from "src/app/services/gtm-segment.service";
import { MixpanelService } from "src/app/services/mixpanel.service";
import { SyndicateRepositoryService } from "../../syndicate-repository.service";
import { HeaderComponent } from "../../../../components/header/header.component";

@Component({
    selector: "app-dont-want-to-play",
    templateUrl: "./dont-want-to-play.component.html",
    styleUrls: ["./dont-want-to-play.component.scss"],
    standalone: true,
    imports: [
        HeaderComponent,
        IonicModule,
        TranslatePipe,
    ],
})
export class DontWantToPlayComponent implements OnInit {
  pageTitle = "Leave syndicate";
  reason = "donot-want-play";
  syndicateName: Data | string;
  constructor(
    public translate: TranslateService,
    private modalCtrl: ModalController,
    private navParams: NavParams,
    private GTMSegment: GTMSegmentService,
    private mixPanelService: MixpanelService,
    private authService: AuthService,
    private router: Router,
    private syndicateService: SyndicateRepositoryService,
  ) {
    this.GTMSegment.GTMPopupInitialization("leaveSyndicateReasonPopup-2");
  }

  ngOnInit() {
    this.syndicateName = this.navParams?.data.s_name;
    this.translate.get(["dont-want.pageTitle"]).subscribe(
      (res: string) => {
        this.pageTitle = res["dont-want.pageTitle"];
      },
      (err) => {
        return err;
      }
    );
    this.authService
      ?.getUid("DontWantToPlayComponent")
      ?.then((uid) => {
        this.mixPanelService.init(uid);
        this.trackJackpotTriggerContentViewed();
      })
      .catch((error) => error);
  }

  backToLeaveSyndicate() {
    this.modalCtrl.dismiss().catch(err => { return err });
  }

  leave() {
    this.modalCtrl.dismiss(this.reason).catch(err => { return err });
  }

  closeAndRedirect() {
    this.trackJackpotTriggerCtaClicked();
    this.router.navigateByUrl(
      "/mainTabs/tabs/store?TP1=downgrade&tip=jackpot_trigger#jackpot_trigger"
    );
    this.syndicateService?.closeAllDialogs();
  }

  private trackJackpotTriggerContentViewed(): void {
    this.mixPanelService.syndicateCancellationMixpanel(
      "I don't want to play weekly",
      "Jackpot Trigger cancellation content",
      "view",
      "Jackpot Trigger cancellation content viewed"
    );
    this.GTMSegment.trackEvent("Jackpot Trigger cancellation content viewed", {
      cancellation_step: "I don't want to play weekly",
      cancellation_screen_name: "Jackpot Trigger cancellation content",
    });
  }

  private trackJackpotTriggerCtaClicked(): void {
    this.mixPanelService.syndicateCancellationMixpanel(
      "I don't want to play weekly",
      "Jackpot Trigger cancellation content",
      "cta_click",
      "View Jackpot Triggers"
    );
    this.GTMSegment.trackEvent("Jackpot Trigger cancellation CTA clicked", {
      cancellation_step: "I don't want to play weekly",
      cancellation_screen_name: "Jackpot Trigger cancellation content",
      destination: "/mainTabs/tabs/store?TP1=downgrade&tip=jackpot_trigger#jackpot_trigger",
    });
  }
}
